<template>
  <div id="shopList">
    <div class="big-box">
      <div class="left-box">
        <div class="left-header">
          <div class="sort-box">
            <div
              class="default-sort"
              :class="sortType == 'default'?'checkSort':''"
              @click="setSort('default')"
            >
              <span>默认排序</span>
            </div>
            <div
              class="sell-sort"
              :class="sortType == 'sell'?'checkSort':''"
              @click="setSort('sell')"
            >
              <span>销 量</span>
            </div>
          </div>
          <div class="page-box">
            <div class="zuo" @click="prev(page - 1)">
              <i class="iconfont icon-zuo"></i>
            </div>
            <div class="page">
              <span style="color:red">{{page}}</span>
              /{{Math.ceil(total/10) }}
            </div>
            <div class="you" @click="next(page + 1)">
              <i class="iconfont icon-you"></i>
            </div>
          </div>
        </div>
        <div class="left-table" v-loading="loading">
          <div
            @click="routerInfo(item.id)"
            v-for="(item,index) in tableData"
            :key="index"
            class="table-item"
          >
            <div class="logo-box">
              <img class="logo" :src="serve + item.logo" alt />
            </div>
            <div class="shop-info">
              <div class="shop-title red-text">{{item.company}}</div>
              <div class="seller">
                <span>卖家 ：</span>
                <span class="blue-text">{{item.address}}</span>
              </div>
              <div class="main">
                <span>主营 ：</span>
                <span class="blue-text red-text">{{item.main_product}}</span>
              </div>
              <div class="all-product">共{{item.productCount}}件商品</div>
            </div>
            <div class="product-img">
              <div
                v-for="(product,index) in item.product"
                :key="index"
                class="img-item margin-r"
                @click.stop="routerProduct(product.id)"
              >
                <img class="img-size" :src="serve + product.images" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="left-page">
          <!-- <div class="prev" @click="prev(page - 1)">上一页</div> -->
          <div class="page">
            <el-pagination
              :current-page="page"
              @current-change="setPage"
              background
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :total="total"
              hide-on-single-page
            ></el-pagination>
          </div>
          <!-- <div class="next" @click="prev(page + 1)">下一页</div> -->
        </div>
      </div>
      <div class="right-box">
        <div class="header">
          <span style="margin-left:10px">热卖推荐</span>
        </div>
        <div
          v-for="item in hotNumber"
          :key="item"
          class="product"
          @click="routerProduct(hotSellList[item].p_id)"
        >
          <img class="product-img" :src="serve + hotSellList[item].images" alt />
          <div class="product-title">{{hotSellList[item].title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parse } from "path";
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      tableData: [],
      total: 0,
      page: 1,
      loading: false,
      sortType: "",
      hotNumber: 0,
      hotSellList: []
    };
  },
  activated() {
    this.$store.commit("set_top_nav", "8");
  },
  created() {
    this.getShopList();
    this.hotSell();
  },
  methods: {
    hotSell() {
      this.axios.get(this.serve + "/search_ad").then(res => {
        var data = res.data;
        this.hotSellList = data;
      });
    },
    routerProduct(id) {
      var pathUrl = "/product/" + id;
      let routerJump = this.$router.resolve({
        path: pathUrl
      });
      window.open(routerJump.href, "_blank");
    },
    routerInfo(id) {
      var pathUrl = "/shop/shopInfo";
      let routerJump = this.$router.resolve({
        path: pathUrl,
        query: { id: id }
      });
      window.open(routerJump.href, "_blank");
    },
    setSort(type) {
      this.sortType = type;
      this.getShopList();
    },
    setPage(page) {
      this.page = page;
      this.getShopList();
    },
    prev(page) {
      if (page < 1) {
        return;
      }
      this.page = page;
      this.getShopList();
    },
    next(page) {
      if (page > Math.ceil(this.total / 10)) {
        return;
      }
      this.page = page;
      this.getShopList();
    },
    getShopList() {
      var where = {
        page: this.page,
        sort: this.sortType
      };
      this.loading = true;
      this.axios
        .get(this.serve + "/shop/shopList", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.tableData = data.data.results;
            if (data.data.results.length < 5) {
              this.hotNumber = data.data.results.length - 1;
            } else {
              this.hotNumber = data.data.results.length - 2;
            }

            this.total = data.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
#shopList {
  width: 100%;
  min-height: 300px;
  border-top: 2px solid #e2211c;
  min-height: 1000px;
  .big-box {
    width: 1200px;
    margin: 30px auto 0 auto;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .left-box {
      width: 1010px;
      .left-header {
        width: 1008px;
        height: 38px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        .sort-box {
          display: flex;
          .default-sort {
            width: 136px;
            height: 36px;
            border: 1px solid rgba(221, 221, 221, 1);
            line-height: 36px;
            text-align: center;
            cursor: pointer;
          }
          .sell-sort {
            width: 80px;
            height: 36px;
            border: 1px solid rgba(221, 221, 221, 1);
            line-height: 36px;
            text-align: center;
            cursor: pointer;
          }
          .checkSort {
            background: rgba(255, 255, 255, 1);
          }
        }
        .page-box {
          display: flex;
          align-items: center;
          margin-right: 20px;

          .zuo {
            width: 20px;
            font-size: 10px;
            color: #999999;
          }
          .zuo:hover {
            font-size: 14px;
            color: black;
            cursor: pointer;
          }
          .page {
            margin: 0 20px 0 20px;
          }
          .you {
            width: 20px;
            font-size: 10px;
            color: #999999;
          }
          .you:hover {
            font-size: 14px;
            color: black;
            cursor: pointer;
          }
        }
      }
      .left-table {
        margin-top: 20px;
        width: 1010px;
        .table-item {
          width: 1010px;
          height: 200px;
          background: rgba(255, 255, 255, 1);
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .logo-box {
            margin-left: 20px;
            border: 1px solid rgba(221, 221, 221, 1);
            .logo {
              width: 98px;
              height: 98px;
            }
          }
          .shop-info {
            width: 348px;
            margin-left: 24px;
            font-weight: 400;
            .shop-title {
              font-size: 16px;
              font-family: Microsoft YaHei;
              color: rgba(0, 99, 220, 1);
              line-height: 22px;
              white-space: nowrap;
              overflow: hidden;
            }
            .blue-text {
              color: rgba(0, 99, 220, 1);
            }
            .seller {
              font-size: 14px;
              margin: 19px 0 19px 0;
              white-space: nowrap;
              overflow: hidden;
            }
            .main {
              margin-bottom: 19px;
              white-space: nowrap;
              overflow: hidden;
            }
            .all-product {
              color: rgba(102, 102, 102, 1);
            }
          }
          .product-img {
            margin-left: 30px;
            height: 152px;
            width: 470px;
            display: flex;
            .img-item {
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              .img-size {
                width: 150px;
                height: 150px;
              }
            }
            .margin-r {
              margin-right: 10px;
            }
          }
        }
        .table-item:hover {
          cursor: pointer;
          .red-text {
            color: #e2211c;
          }
        }
      }
      .left-page {
        display: flex;
        justify-content: center;
        line-height: 30px;
        text-align: center;
        .prev {
          width: 50px;
        }
        .page {
          min-width: 100px;
        }
        .next {
          width: 50px;
        }
        .next:hover {
          color: #e2211c;
          cursor: pointer;
        }
        .prev:hover {
          color: #e2211c;
          cursor: pointer;
        }
      }
    }
    .right-box {
      .header {
        width: 176px;
        height: 38px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 38px;
      }
      .product {
        width: 176px;
        height: 248px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        .product-img {
          width: 176px;
          height: 180px;
        }
        .product-title {
          margin: 17px auto 0 auto;
          width: 153px;
          height: 36px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 18px;
          overflow: hidden;
        }
      }
      .product:hover {
        color: #e2211c;
        cursor: pointer;
      }
    }
  }
}
</style>